import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class HomepageBlogItem {
    @observable id!: number;
    @observable img!: string;
    @observable title!: string;
    @observable description!: string;
    @observable url!: string;
    @observable subdomain!: string;
    @observable order!: number;

    constructor(item?: ModelProperties<HomepageBlogItem>) {
        if (item) {
            construct(this, item);
        }
    }
}